export interface LoginAlertProps {
    severity?: "success" | "error";
    children?: React.ReactNode;
}

export default function LoginAlert({ children }: LoginAlertProps) {
    return <div tw="text-white">{children}</div>;
}
